import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { metaReducers, reducers } from './reducers';
import { extModules } from 'src/environments/environment';
import { effects } from './effects';
import { NotificationsModule } from './notifications/notifications.module';
import { CookieService } from 'ngx-cookie-service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TransferModule } from './transfer/transfer.module';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { Router } from '@angular/router';
import * as Sentry from "@sentry/angular";
import { GlobalBindsDirective } from './util/global-binds.directive';
import { OverlayModule } from '@angular/cdk/overlay';

export function windowFactory() {
  return window;
}

@NgModule({
  declarations: [
    AppComponent,
    GlobalBindsDirective,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    OverlayModule,
    HttpClientModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    // // Instrumentation must be imported after importing StoreModule
    extModules,
    EffectsModule.forRoot(effects),
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    CoreModule,
    SharedModule,
    NotificationsModule,
    TransferModule,
    AppRoutingModule,
    ClipboardModule
  ],
  providers: [
    CookieService,
    { provide: 'window', useFactory: windowFactory },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  constructor() {
}
}
